import script from "./OrdersPartialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersPartialsPage.vue?vue&type=script&setup=true&lang=js"

import "./OrdersPartialsPage.vue?vue&type=style&index=0&id=758927b2&lang=css"
import "./OrdersPartialsPage.vue?vue&type=style&index=1&id=758927b2&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758927b2"]])

export default __exports__